<script lang="ts" setup>
import SnippetItem from './SnippetItem.vue';
import type { TCategorySidebar } from '../types';
import { useSnippetCategory } from '../hooks/useSnippetCategory';
type TSnippetCategoryProps = {
  item: TCategorySidebar;
};
const NO_ORDER_CATEGORIES = ['thirdparty', 'other_elements'];

const props = defineProps<TSnippetCategoryProps>();

const { item, getClassesWrapper, snippets } = useSnippetCategory(props);
</script>
<template>
  <div
    class="gf-snippet-category"
    :class="{ 'gf-snippet-category--no-order': NO_ORDER_CATEGORIES.includes(item.key) }"
    :data-cat="item.key">
    <div :id="`toggle-header-${item.id}`" :class="getClassesWrapper()">
      <span>{{ item.name }}</span>
      <span class="gf-sperator-element_toggler"> </span>
    </div>
    <div class="gf_snippets-list">
      <SnippetItem v-for="snippet in snippets" :key="snippet.id" :category="item.key" :item="snippet" />
    </div>
  </div>
</template>
